import React from 'react';
import memoizeOne from 'memoize-one';
import SimpleActions from './SimpleActions';
import { camelCaseEmptyStringRecursive } from '../../../services/utils';

const columns = memoizeOne((handleClick, onlyShow) => [
  {
    name: 'Trabajador',
    id: 'full_name',
    cell: item => {
      return (
        <div className="d-flex flex-column" role="presentation">
          <span data-tag="allowRowEvents">{item?.full_name}</span>
          <span className="text-muted" data-tag="allowRowEvents">
            {item?.national_identification || item?.nationalIdentification}
          </span>
        </div>
      );
    },
    grow: '1',
    sortable: true
  },
  {
    name: 'Reliquidacion Afp',
    selector: 'parsed_afp_amount',
    id: 'afp_amount',
    grow: '1',
    sortable: true
  },
  {
    name: 'Reliquidacion Salud',
    selector: 'parsed_health_amount',
    id: 'health_amount',
    grow: '1',
    sortable: true
  },
  {
    name: 'Reliquidacion Seg Cesantia',
    selector: 'parsed_afc_employee_amount',
    id: 'afc_employee_amount',
    grow: '1',
    sortable: true
  },
  {
    name: 'Reliquidacion Aportes',
    selector: 'parsed_total_employer_contributions',
    id: 'total_employer_contributions',
    grow: '1',
    sortable: true
  },
  {
    name: 'Liquido',
    selector: 'parsed_liquid_amount',
    id: 'liquid_amount',
    grow: '1',
    sortable: true
  },
  {
    name: 'Acciones',
    selector: 'actions',
    cell: item => (
      <SimpleActions handleClick={handleClick} item={camelCaseEmptyStringRecursive(item)} onlyShow={onlyShow} />
    ),
    width: '180px',
    id: 'actions',
    grow: '1'
  }
]);

export default columns;
